import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import * as Yup from "yup";

import RenderFields from "Components/RenderFields";
import { getOptionValue, meterTypes, ltLoadOptions } from "common/enums";
import { htLoadOptions, SUPER_ADMIN } from "common/constant";

import { onlyNumberKeys } from "utils";

export const inputFields = (type, isSerialNumberEditable) => [
  {
    label: "Type",
    name: "type",
    options: meterTypes,
    isRequired: true,
  },
  {
    label: "Make",
    name: "make",
    placeholder: "Enter Make",
    isRequired: true,
  },
  {
    label: "Sr. Number",
    name: "srNo",
    placeholder: "Enter Serial Number",
    isRequired: true,
    disabled: isSerialNumberEditable,
  },
  {
    label: "Lab Number",
    name: "labNo",
    placeholder: "Enter Lab Number",
  },
  {
    label: "Phase/Wire",
    name: "phaseOrWire",
    options:
      type === getOptionValue("meterTypes", "Liberty 200")
        ? ltLoadOptions
        : htLoadOptions,
    isRequired: true,
  },
  {
    label: "Voltage Rating",
    name: "voltageRating",
    placeholder: "Enter Voltage Rating",
    isRequired: true,
  },
  {
    label: "Current Rating",
    name: "currentRating",
    placeholder: "Enter Current Rating",
    isRequired: true,
  },
  {
    label: "Meter CTR",
    name: "meterCTR",
    placeholder: "Enter Meter CTR",
    isRequired: true,
    validationSchema: Yup.string()
      .required("Line CT ratio is required")
      .matches(/^\d+[/]\d+$/, "Enter valid ratio"),
  },
  {
    label: "Meter PTR",
    name: "meterPTR",
    placeholder: "Enter Meter PTR",
    isRequired: true,
    validationSchema: Yup.string()
      .required("Line CT ratio is required")
      .matches(/^\d+[/]\d+$/, "Enter valid ratio"),
  },
  {
    label: "Pulse/kWh",
    name: "pulseOrkwH",
    placeholder: "Enter Pulse/kWh",
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e),
    isRequired: true,
  },
  {
    label: "Class",
    name: "class",
    placeholder: "Enter Class",
    isRequired: true,
  },
  {
    label: "Dial MF",
    name: "dialMF",
    placeholder: "Enter Dial MF",
    type: "number",
    onKeyDown: (e) => onlyNumberKeys(e, true),
    isRequired: true,
  },
];

const MeterDetails = ({ formik }) => {
  const {
    values: {
      meter: { type },
      extraValues: { srNo },
    },
  } = formik;

  const { roles } = useSelector((state) => state.Login);
  return (
    <RenderFields
      formik={formik}
      inputFields={inputFields(type, !(roles.includes(SUPER_ADMIN) || !srNo))}
      parentKey="meter"
    />
  );
};

MeterDetails.propTypes = {
  formik: PropTypes.object,
};

export default MeterDetails;
